import CONFIG from 'shared/constants/config';
import { isTMA } from '@tma.js/sdk-react';
import { getMaxInitDataRawString } from 'shared/helpers/max/maxBridge';

export type AuthEnvironment = 'telegram' | 'max' | 'native_webview' | 'browser';

const isMaxEnv = () => {
  return (
    typeof (window as Window & { WebApp?: unknown }).WebApp !== 'undefined' &&
    !!getMaxInitDataRawString()
  );
};

const isNativeWebView = () => {
  // 1) Стандартный признак react-native-webview
  const hasBridge =
    typeof (window as any).ReactNativeWebView?.postMessage === 'function';

  // 2) Доп. флаг, который мы выставляем из нативки в injectedBeforeLoad
  const hasFlag = Boolean((window as any).__NATIVE_WEBVIEW__ === true);

  return hasBridge || hasFlag;
};

export const detectAuthEnvironment = (): AuthEnvironment => {
  const sp = new URLSearchParams(window.location.search);

  // ✅ 1. Приоритет MAX Mock (для разработки)
  if (sp.get('max_mock') === 'true') return 'max';

  // ✅ 2. Legacy/Native
  if (sp.get('native_token') || sp.get('token')) return 'native_webview';
  if (isNativeWebView()) return 'native_webview';

  // ✅ 3. Реальное окружение MAX (по наличию initData)
  if (isMaxEnv()) return 'max';

  // ✅ 4. Telegram (библиотека tma сама проверяет окружение)
  if (isTMA()) return 'telegram';

  return CONFIG.ENV_MOCK ? 'telegram' : 'browser';
};
